import { useMemo } from "react";

interface Photo {
  prefix?: string;
  suffix?: string;
}

export const CardImage = ({
  photo,
  title,
}: {
  photo?: Photo;
  title: string;
}) => {
  const [width, height] = useMemo(() => {
    let w = 600;
    if (typeof window !== "undefined") {
      const cardMaxWidth = parseInt(
        window
          .getComputedStyle(document.body)
          .getPropertyValue("--card-max-width"),
        10
      );
      if (window.innerWidth <= cardMaxWidth) w = window.innerWidth;
    }

    const h = w * (5 / 8);
    return [w, h];
  }, []);

  if (!photo) return null;

  return (
    <img
      style={{
        display: "block",
        maxWidth: "var(--card-max-width)",
        width: "100%",
      }}
      src={`${photo.prefix || ""}${width}x${height}${photo.suffix || ""}`}
      alt={title}
      width={width}
      height={height}
    />
  );
};
